module.exports = __webpack_public_path__ + "static/media/unverified-orders-menu-icon.b810c4eb.svg";